import './components/ga-events';            //should be on top of each page's JS file
import './components/swipe-for-more';       // should be as soon as possible
import './parts/navigation';
import './parts/keyboard-navigation';
import './parts/accept-cookies';
import './parts/ftc-disclosure';
import './components/accessibility-widget';
import Tooltips from './components/tooltips';
import './components/js-links';
import '../vendor/splide.min';
import './widgets/quick-nav';
import './components/gallery';
import './components/youtube-facade';
import './components/show-hide-on-visible-position';
import './components/scroll-top-btn';
import './components/accordion-pw';
import './components/svg';
import './parts/vendor-review';

import ExitPopup from './components/exit-popup';

import $ from 'cash-dom';
import PrequalState from './parts/ppc/prequalify-modal/PrequalState';
import CustomSelect from './components/custom-select';
import loadDisclosureBanner from './parts/disclosure-banner-loader';
import initProsConsTabs from './parts/article/pros-cons-tabs';

PrequalState.getInstance().isPrequalShown = false;

if ($('#top_loans_carousel').length > 0) {
    new Splide('#top_loans_carousel').mount();
}

if ($('#top_loans_carousel_2').length > 0) {
    new Splide('#top_loans_carousel_2').mount();
}

if ($('#categories_carousel').length > 0) {
    new Splide('#categories_carousel').mount();
}

$(function () {
    ExitPopup.init();
    Tooltips.getInstance().initOnce();
    CustomSelect.init();
    loadDisclosureBanner();
    initProsConsTabs();
});